import { render, staticRenderFns } from "./EditUserRole.vue?vue&type=template&id=73da751c&scoped=true"
import script from "./EditUserRole.vue?vue&type=script&lang=js"
export * from "./EditUserRole.vue?vue&type=script&lang=js"
import style0 from "./EditUserRole.vue?vue&type=style&index=0&id=73da751c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da751c",
  null
  
)

export default component.exports